import { TelephoneNumber } from 'modules/types/TelephoneNumber';

export const concatAreaCodeAndNumber = (phone?: TelephoneNumber) => {
  if (phone?.areaCode && phone?.number) {
    return phone?.areaCode + phone?.number;
  }
  return phone?.number;
};
